<template>
    <div>
        <transition name="fade">
            <div class="auth-modal" id="onetime-offer-modal">
                <div class="modal-backdrop" @click="closeByBackdrop">
                    <div class="modal-content relative" style="height: min-content">
                        <InnerLoader v-if="isLoading" :z-index="999" />
                        <NoPaymentOverlay v-if="!isLoading" @close="closeByOverlay" :z-index="999" />

                        <div class="modal-header">
                            <div class="text-right">
                                <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                            </div>
                        </div>

                        <div class="modal-body">
                            <div class="text-center auth-popup-header payment-popup-header">
                                <h2 class="text-xl md:text-3xl my-1 shadow-text-none">
                                    {{
                                        !isNotOnetimeOffer
                                            ? translate('purchase_header_one_time_offer', {
                                                  discountPercent: discountPercent
                                              })
                                            : translate('purchase_header_not_one_time_offer')
                                    }}
                                </h2>
                                <h4 class="mb-0 shadow-text-none text-lg mt-0 font-thin">
                                    {{
                                        !isNotOnetimeOffer
                                            ? translate('purchase_header_one_time_offer_description', {
                                                  limitPlayer: subscriptionPlans[selectedPlanIndex].player
                                              })
                                            : translate('purchase_header_not_one_time_offer_description')
                                    }}
                                </h4>
                            </div>
                            <div class="plan-block m-auto max-w-xs">
                                <div class="plan-item system-border" v-if="!isNotOnetimeOffer">
                                    <div
                                        class="flex w-full justify-center items-center p-2 plan-title system-border-bottom"
                                    >
                                        <div>
                                            <button
                                                @click="selectPrevPlan"
                                                :class="{
                                                    'text-3xl payment-control-btn': true,
                                                    'system-primary-text-color': true,
                                                    'cursor-pointer': !isFirstPlan,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        isFirstPlan
                                                }"
                                            >
                                                <IconMinusCircle />
                                            </button>
                                        </div>
                                        <div class="text-4xl mx-3 font-bold font-size-28">
                                            <i class="fas fa-users mr-2" style="text-shadow: none"></i>
                                            {{ subscriptionPlans[selectedPlanIndex].player }}
                                        </div>
                                        <div>
                                            <button
                                                @click="selectNextPlan"
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer': !isFinalPlan,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        isFinalPlan
                                                }"
                                            >
                                                <IconPlusCircle />
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        class="text-3xl md:text-5xl mt-1 pb-1 mb-0 mx-0 text-center plan-title system-border-bottom"
                                    >
                                        <h3
                                            class="m-0 price-text text-4xl shadow-text-none font-size-28"
                                            ref="priceText"
                                        >
                                            <span class="text-old-price pr-3">
                                                ${{
                                                    Math.ceil(
                                                        subscriptionPlans[selectedPlanIndex].amount /
                                                            (discountPercent / 100)
                                                    )
                                                }}
                                            </span>
                                            ${{ subscriptionPlans[selectedPlanIndex].amount }}
                                        </h3>
                                    </div>
                                    <div class="footer-area p-4">
                                        <ul class="plan-list" style="text-align: left; padding: 0px 30px">
                                            <li class="text-base">
                                                <i
                                                    class="fas fa-check-square mr-2"
                                                    style="color: #00b114; text-shadow: none"
                                                ></i>
                                                {{
                                                    translate('purchase_plan_one_time_offer_list_1', {
                                                        limitPlayer: subscriptionPlans[selectedPlanIndex].player
                                                    })
                                                }}
                                            </li>
                                            <li class="text-base">
                                                <i
                                                    class="fas fa-check-square mr-2"
                                                    style="color: #00b114; text-shadow: none"
                                                ></i>
                                                {{ translate('purchase_plan_one_time_offer_list_2') }}
                                            </li>
                                            <li class="text-base">
                                                <i
                                                    class="fas fa-check-square mr-2"
                                                    style="color: #00b114; text-shadow: none"
                                                ></i>
                                                {{ translate('purchase_plan_one_time_offer_list_3') }}
                                            </li>
                                        </ul>
                                        <div class="offer-box">
                                            <div style="text-align: center">
                                                <span class="font-bold text-2xl shadow-text-none">
                                                    {{
                                                        $t('purchase_one_time_offer_discount', {
                                                            discountPercent: discountPercent
                                                        })
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="font-semibold shadow-text-none"
                                                style="text-align: center; font-size: 16px"
                                            >
                                                {{ $t('purchase_subscription_ai_description') }}
                                            </div>
                                        </div>
                                        <button
                                            v-if="geoLocation && geoLocation.code == 'NO'"
                                            @click="setVippsModal(subscriptionPlans[selectedPlanIndex])"
                                            class="btn btn-outline btn-vipps w-full font-opensans font-size-15 mb-1 mt-4"
                                            style="padding: 0.7rem 0"
                                            type="button"
                                        >
                                            {{ $t('purchase_button_vipps') }}
                                        </button>
                                        <form @submit.prevent="subscribeByPaypal" :action="agreementUrl" method="post">
                                            <input
                                                :value="subscriptionPlans[selectedPlanIndex].id"
                                                name="id"
                                                type="hidden"
                                            />
                                            <input
                                                :value="subscriptionPlans[selectedPlanIndex].plan_id"
                                                name="plan_id"
                                                type="hidden"
                                            />
                                            <button
                                                @click="
                                                    subscribeByStripe(
                                                        'stripe' + selectedPlanIndex,
                                                        subscriptionPlans[selectedPlanIndex].stripe
                                                    )
                                                "
                                                type="button"
                                                class="btn btn-outline btn-stripe w-full font-opensans font-size-15"
                                            >
                                                {{ translate('purchase_button_stripe') }}
                                            </button>
                                            <button
                                                class="btn btn-block btn-paypal text-sm font-opensans mb-1 mt-2 flex justify-center items-center"
                                            >
                                                <PaypalLogo></PaypalLogo>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <div class="pt-20 pb-20" v-else>
                                    <button
                                        @click="onOnetimeOffer"
                                        type="button"
                                        class="btn btn-outline system-button-color system-button-text-color w-full font-opensans font-size-15 mt-8"
                                    >
                                        {{ translate('purchase_botton_not_one_time_offer') }}
                                    </button>
                                </div>
                            </div>

                            <div class="max-w-md m-auto">
                                <div class="text-center mt-4 mx-4">
                                    <p class="text-base text-lg shadow-text-none mb-1">
                                        <a href="/purchase" target="_blank" class="text-dark-charcoal font-bold">{{
                                            translate('purchase_plan_one_time_offer_list_4')
                                        }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <Vipps
            @close="resetVipps"
            @subscription="onSubscription"
            :amount="vippsData.item ? vippsData.item.amount : ''"
            :title="vippsData.item ? vippsData.item.title : ''"
            :open="vippsData.status"
            :is-subscription="isSubscriptionVipps"
            :vipps-data="vippsData"
        />
    </div>
</template>

<script>
import appConfig from '@/app.config'
import Request from '@/lib/request'
import { currentUser } from '@/lib/user'
import { loadStripe } from '@stripe/stripe-js'
import InnerLoader from '@/components/InnerLoader'
import randomize from 'randomatic'
import UserService from '@/lib/user.js'
import helperMixin from '@/mixins/helper'
import PaypalLogo from '@/components/PaypalLogo'
import IconPlusCircle from '../components/IconPlusCircle'
import IconMinusCircle from '../components/IconMinusCircle'
import Vipps from '@/components/VippsPayment'
import NoPaymentOverlay from '@/components/NoPaymentOverlay'

export default {
    name: 'PaymentPopup',

    components: {
        InnerLoader,
        PaypalLogo,
        IconPlusCircle,
        IconMinusCircle,
        Vipps,
        NoPaymentOverlay
    },

    mixins: [helperMixin],

    data() {
        return {
            showCloseButton: false,
            isLoading: false,
            selectedPlanIndex: 0,
            subscriptionPlans: [
                {
                    amount: 39.99,
                    player: 30,
                    frequency: 'Year'
                }
            ],
            selectedOneTimeOffer: {},
            plans: [],
            isFinalPlan: false,
            isFirstPlan: true,
            publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
            discountPercent: 66.66,
            isNotOnetimeOffer: false,
            isSubscriptionVipps: false,
            vippsData: {
                status: false,
                item: null
            },
            geoLocation: null
        }
    },

    computed: {
        agreementUrl() {
            return `${appConfig.baseUrl}plans/agreement`
        }
    },

    mounted() {
        this.fetchOneTimeOfferPlan()

        this.$store.dispatch('getCurrentCountry').then(res => {
            this.geoLocation = res.data.data
        })
    },

    methods: {
        onSubscription(type) {
            this.isSubscriptionVipps = type
        },

        resetVipps() {
            this.toggleLoading(false)
            this.vippsData = {
                status: false,
                item: null
            }
        },

        setVippsModal(data) {
            this.toggleLoading(true)

            this.checkAuthUser().then(() => {
                var payload = {
                    amount: parseFloat(data.amount * 10).toFixed(2)
                }

                payload['title'] = this.$t('vipps_modal_description', { limitPlayer: data.player })
                payload['interval'] = {
                    unit: 'YEAR',
                    count: 1
                }
                payload['limitPlayer'] = data.player
                payload['payment_on'] = 'access'
                payload['plan_id'] = data.plan_id

                this.isSubscriptionVipps = true

                this.vippsData = {
                    status: true,
                    item: payload
                }

                this.toggleLoading(false)
            })
        },

        onOnetimeOffer() {
            this.isNotOnetimeOffer = false
        },

        closeByBackdrop(e) {
            if (this.isLoading) {
                return
            }

            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }

            this.closeModal()
        },

        closeModal() {
            if (!this.isNotOnetimeOffer) {
                this.isNotOnetimeOffer = true

                return
            }

            this.$emit('close')
        },

        animatePrice() {
            this.$refs.priceText.style.transform = 'scale(1.5)'
            setTimeout(() => {
                this.$refs.priceText.style.transform = 'scale(1)'
            }, 400)
        },

        selectNextPlan() {
            if (this.selectedPlanIndex + 1 >= this.subscriptionPlans.length) {
                return
            }

            let planIndex = this.selectedPlanIndex + 1

            this.animatePrice()
            this.isFinalPlan = planIndex + 1 == this.subscriptionPlans.length ? true : false
            this.selectedPlanIndex++
            this.isFirstPlan = this.selectedPlanIndex > 0 ? false : true
            this.findSubscriptionPlan(this.subscriptionPlans[this.selectedPlanIndex])
        },

        selectPrevPlan() {
            if (this.selectedPlanIndex <= 0) {
                return
            }

            this.animatePrice()
            this.isFinalPlan = this.selectedPlanIndex - 1 == this.subscriptionPlans.length ? true : false
            this.selectedPlanIndex--
            this.isFirstPlan = this.selectedPlanIndex < 1 ? true : false
            this.findSubscriptionPlan(this.subscriptionPlans[this.selectedPlanIndex])
        },

        findSubscriptionPlan(selectBuyPlan) {
            const found = this.subscriptionPlans.find(plan => {
                return plan.player == selectBuyPlan.player
            })
            if (found) {
                this.selectedOneTimeOffer = {
                    amount: found.amount,
                    player: found.player
                }
            } else {
                this.selectedOneTimeOffer = {}
            }
        },

        fetchOneTimeOfferPlan() {
            this.isLoading = true

            const request = new Request()
            var condition = {
                recurring: {
                    interval: 'year'
                }
            }

            request
                .post(appConfig.api.getOneTimeOfferPlan, condition)
                .then(res => {
                    this.subscriptionPlans = res.data.data
                    this.isLoading = false
                })
                .catch(() => {
                    this.isLoading = false
                })
        },

        isLoggedIn() {
            const userService = new UserService()
            return userService.isLoggedIn()
        },

        subscribeByStripe(refKey, payload) {
            this.checkAuthUser().then(() => {
                const request = new Request()
                var plan = payload
                plan['user_id'] = currentUser().id
                plan['track'] = randomize('A0', 17)

                request.post(appConfig.api.stripeCreateSession, payload).then(res => {
                    if (res.data.message == 'create_session_success') {
                        const session = res.data.data
                        Promise.resolve(loadStripe(this.publicKey)).then(stripe => {
                            stripe.redirectToCheckout({
                                sessionId: session.id
                            })

                            this.toggleLoading(false)
                        })
                    }
                })
            })
        },

        checkAuthUser() {
            const userService = new UserService()
            this.toggleLoading(true)

            return new Promise((resolve, reject) => {
                userService
                    .validateToken()
                    .then(() => {
                        resolve()
                    })
                    .catch(() => {
                        this.openAuthPopup()
                        reject()
                    })
            })
        },

        toggleLoading(status) {
            this.isLoading = status
        },

        subscribeByPaypal(e) {
            this.checkAuthUser().then(() => {
                e.target.submit()

                setTimeout(() => {
                    this.toggleLoading(false)
                }, 2000)
            })
        },

        closeByOverlay() {
            this.isNotOnetimeOffer = false
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/modal.scss';

$input-border-color: #cbcbcb;
$input-border-darker-color: #b6b6b6;

#onetime-offer-modal {
    .font-size-28 {
        font-size: 28px;
    }

    .auth-popup-header {
        &.payment-popup-header {
            margin-bottom: 1rem;

            @media screen and (max-width: 719px) {
                margin-bottom: 1rem;
            }
        }
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.5rem;
        z-index: 9999;
        overflow: auto;

        .modal-content {
            background-color: #fff;
            // margin-top: 4rem;
            padding: 1rem;
            min-width: 720px;
            overflow: hidden;
            border-radius: 3px;
            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

            @media screen and (max-width: 719px) {
                min-width: 90%;
                max-width: 90% !important;
                margin: 1rem 0.5rem;
            }

            .modal-body {
                margin: 0 0 0 0;

                @media screen and (max-width: 719px) {
                    margin: 0 0 1rem 0;
                }
            }
        }
    }

    .plan-block {
        .plan-item {
            border: 1px solid $input-border-darker-color;
            border-radius: 5px;

            .plan-title {
                border-bottom: 1px solid $input-border-darker-color;
            }

            .payment-control-btn {
                background-color: transparent;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 5px;
            }
        }

        .price-text {
            transition: all 0.3s ease;
        }

        .plan-list {
            list-style: none;
            padding: 0;
            margin: 0 0 1rem 0;
            text-align: center;

            li {
                margin-bottom: 5px;
            }
        }

        .opacity-40 {
            opacity: 0.4;
        }
    }

    .btn-outline {
        border: 2px solid white;
        box-shadow: none;
        transition: 0.3s;

        &:hover {
            box-shadow: 0 0 0 rgba(0, 0, 0, 0);
        }
    }

    .btn {
        border-radius: 4px;
    }

    .btn-stripe {
        @include btn-stripe;
    }

    .btn-vipps {
        @include btn-vipps;
    }

    .text-old-price {
        display: inline-block;
        text-decoration: line-through;
        text-decoration-color: #f61811;
        text-decoration-thickness: 4px;
    }

    .footer-area {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 18rem;

        .offer-box {
            color: #3e9d03;
        }
    }
}
</style>
